// pages/Dashboard.jsx

import React, { useState } from "react";
import JobCard from "./JobCard";
import JobDetails from "./JobDetails";

const jobData = [
  {
    title: "Warehouse Worker",
    company: "Martin Brower",
    location: "Oshawa, ON",
    method: "normal",
  },
  {
    title: "Entry Level Sales Representative",
    company: "American Income Life - Canada",
    location: "Toronto, ON",
    method: "quick",
  },
  {
    title: "Sr. Developers: Golang",
    company: "W3Global Inc",
    location: "Toronto, ON",
    method: "quick",
  },
  {
    title: "Sales Representative",
    company: "American Income Life - Canada",
    location: "Bradford, ON",
    method: "quick",
  },
  {
    title: "UI/UX Lead with Drupal Exp.",
    company: "W3Global Inc",
    location: "Toronto, ON",
    method: "quick",
  },
  {
    title: "Warehouse Free Sample Associate",
    company: "CDS (Club Demonstration Services)",
    location: "Toronto, ON",
    type: "Part-time",
    method: "quick",
  },
  {
    title: "Warehouse Free Sample Associate",
    company: "CDS (Club Demonstration Services)",
    location: "Newmarket, ON",
    type: "Part-time",
    method: "quick",
  },
  {
    title: "Cleaner / Custodian - Days",
    company: "Uline, Inc.",
    location: "Toronto, ON",
    type: "Full-time",
    method: "quick",
  },
];

const Dashboard = () => {
  const [selectedJob, setSelectedJob] = useState(null);

  return (
    <div className="min-h-screen bg-white flex">
      {/* Left: Job list */}
      <div className="w-[35%] border-r px-6 py-6 overflow-y-auto h-screen">
        <h2 className="text-2xl font-bold mb-6">Good Morning, Kelly</h2>
        <div className="space-y-4">
          {jobData.map((job, idx) => (
            <div
              key={idx}
              onClick={() => setSelectedJob(job)}
              className={`cursor-pointer ${selectedJob?.title === job.title ? "ring-2 ring-black" : ""}`}
            >
              <JobCard {...job} />
            </div>
          ))}
        </div>
      </div>

      {/* Right: Job details */}
      {selectedJob && (
        <div className="w-[65%] overflow-y-auto h-screen">
          <JobDetails job={selectedJob} onClose={() => setSelectedJob(null)} />
        </div>
      )}
    </div>
  );
};

export default Dashboard;

